/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FaxDocumentReferralDeletedByUser } from './FaxDocumentReferralDeletedByUser';
import {
    FaxDocumentReferralDeletedByUserFromJSON,
    FaxDocumentReferralDeletedByUserFromJSONTyped,
    FaxDocumentReferralDeletedByUserToJSON,
} from './FaxDocumentReferralDeletedByUser';
import type { FaxDocumentSenderSource } from './FaxDocumentSenderSource';
import {
    FaxDocumentSenderSourceFromJSON,
    FaxDocumentSenderSourceFromJSONTyped,
    FaxDocumentSenderSourceToJSON,
} from './FaxDocumentSenderSource';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
} from './FindAllSourceTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface FaxDocument
 */
export interface FaxDocument {
    /**
     * ID of the fax document
     * @type {string}
     * @memberof FaxDocument
     */
    id: string;
    /**
     * Pointer to the document in S3
     * @type {string}
     * @memberof FaxDocument
     */
    s3_key?: string;
    /**
     * Type of document
     * @type {string}
     * @memberof FaxDocument
     */
    mime_type?: string;
    /**
     * The size of the fax
     * @type {number}
     * @memberof FaxDocument
     */
    filesize_bytes?: number;
    /**
     * Number of pages in the fax document
     * @type {number}
     * @memberof FaxDocument
     */
    page_count?: number;
    /**
     * Fax ID from the upstream API
     * @type {string}
     * @memberof FaxDocument
     */
    external_fax_message_id: string;
    /**
     * Number who sent the fax
     * @type {string}
     * @memberof FaxDocument
     */
    sender_fax_number: string;
    /**
     * Number who received the fax
     * @type {string}
     * @memberof FaxDocument
     */
    receiver_fax_number: string;
    /**
     * Id of the lead the fax is associated with, if applicable
     * @type {string}
     * @memberof FaxDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {FaxDocumentSenderSource}
     * @memberof FaxDocument
     */
    sender_source?: FaxDocumentSenderSource;
    /**
     * 
     * @type {FindAllSourceTags200ResponseDataInner}
     * @memberof FaxDocument
     */
    receiver_facility?: FindAllSourceTags200ResponseDataInner;
    /**
     * When the fax was created (ISO)
     * @type {Date}
     * @memberof FaxDocument
     */
    date_created: Date;
    /**
     * When the fax was deleted (ISO)
     * @type {Date}
     * @memberof FaxDocument
     */
    date_deleted?: Date;
    /**
     * Whether or not the fax was successfully received
     * @type {boolean}
     * @memberof FaxDocument
     */
    is_error: boolean;
    /**
     * Status of the fax with respect to referrals
     * @type {string}
     * @memberof FaxDocument
     */
    referral_status?: FaxDocumentReferralStatusEnum;
    /**
     * 
     * @type {FaxDocumentReferralDeletedByUser}
     * @memberof FaxDocument
     */
    referral_deleted_by_user?: FaxDocumentReferralDeletedByUser;
    /**
     * Whether or not the fax has been read by any user in the organization
     * @type {boolean}
     * @memberof FaxDocument
     */
    is_read?: boolean;
}


/**
 * @export
 */
export const FaxDocumentReferralStatusEnum = {
    ReferralCreated: 'REFERRAL_CREATED',
    ReferralDeleted: 'REFERRAL_DELETED',
    ReferralNotCreatedSpam: 'REFERRAL_NOT_CREATED_SPAM',
    ReferralNotCreatedSupportingDoc: 'REFERRAL_NOT_CREATED_SUPPORTING_DOC',
    Pending: 'PENDING'
} as const;
export type FaxDocumentReferralStatusEnum = typeof FaxDocumentReferralStatusEnum[keyof typeof FaxDocumentReferralStatusEnum];


/**
 * Check if a given object implements the FaxDocument interface.
 */
export function instanceOfFaxDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "external_fax_message_id" in value;
    isInstance = isInstance && "sender_fax_number" in value;
    isInstance = isInstance && "receiver_fax_number" in value;
    isInstance = isInstance && "date_created" in value;
    isInstance = isInstance && "is_error" in value;

    return isInstance;
}

export function FaxDocumentFromJSON(json: any): FaxDocument {
    return FaxDocumentFromJSONTyped(json, false);
}

export function FaxDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'mime_type': !exists(json, 'mime_type') ? undefined : json['mime_type'],
        'filesize_bytes': !exists(json, 'filesize_bytes') ? undefined : json['filesize_bytes'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        'external_fax_message_id': json['external_fax_message_id'],
        'sender_fax_number': json['sender_fax_number'],
        'receiver_fax_number': json['receiver_fax_number'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'sender_source': !exists(json, 'sender_source') ? undefined : FaxDocumentSenderSourceFromJSON(json['sender_source']),
        'receiver_facility': !exists(json, 'receiver_facility') ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['receiver_facility']),
        'date_created': (new Date(json['date_created'])),
        'date_deleted': !exists(json, 'date_deleted') ? undefined : (new Date(json['date_deleted'])),
        'is_error': json['is_error'],
        'referral_status': !exists(json, 'referral_status') ? undefined : json['referral_status'],
        'referral_deleted_by_user': !exists(json, 'referral_deleted_by_user') ? undefined : FaxDocumentReferralDeletedByUserFromJSON(json['referral_deleted_by_user']),
        'is_read': !exists(json, 'is_read') ? undefined : json['is_read'],
    };
}

export function FaxDocumentToJSON(value?: FaxDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        's3_key': value.s3_key,
        'mime_type': value.mime_type,
        'filesize_bytes': value.filesize_bytes,
        'page_count': value.page_count,
        'external_fax_message_id': value.external_fax_message_id,
        'sender_fax_number': value.sender_fax_number,
        'receiver_fax_number': value.receiver_fax_number,
        'lead_id': value.lead_id,
        'sender_source': FaxDocumentSenderSourceToJSON(value.sender_source),
        'receiver_facility': FindAllSourceTags200ResponseDataInnerToJSON(value.receiver_facility),
        'date_created': (value.date_created.toISOString()),
        'date_deleted': value.date_deleted === undefined ? undefined : (value.date_deleted.toISOString()),
        'is_error': value.is_error,
        'referral_status': value.referral_status,
        'referral_deleted_by_user': FaxDocumentReferralDeletedByUserToJSON(value.referral_deleted_by_user),
        'is_read': value.is_read,
    };
}

